import { Card, CardActions, CardContent, CardHeader, CardMedia, Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

// styles
import useStyles from './styles';

// components
import { Button, Typography } from '../../components/Wrappers';
import NewsBanner from '../../components/NewsBanner';

import newOrderImage from '../../images/new-order-dark.jpg';
import viewOrderImage from '../../images/view-order-dark.jpg';
import otherLabWorksImage from '../../images/other-lab-works.jpg';
import { newsData } from './news';

const Dashboard = () => {
    const classes = useStyles();
    const history = useHistory();

    const handleViewOrder = () => history.push('/app/order/list?orderStatus=in-progress');

    const handleCreateOrder = () => history.push('/app/order/add');

    const handleOtherLabWorks = () => history.push('/app/order/other-lab-works');

    const CreateOrderCard = () => (
        <Card className={classes.cardMedia}>
            <CardHeader title="Create a New Aligner Case" />
            <CardMedia className={classes.media} image={newOrderImage} title="Create a New Aligner Case" />
            <CardContent>
                <Typography variant="body2" color="textSecondary" component="p">
                    Upload the 3D scan files of a patient and submit a new order to request a treatment
                </Typography>
            </CardContent>
            <CardActions>
                <Button size="small" color="secondary" onClick={handleCreateOrder}>
                    Create
                </Button>
            </CardActions>
        </Card>
    );

    const ViewOrdersCard = () => (
        <Card className={classes.cardMedia}>
            <CardHeader title="View My Orders" />
            <CardMedia className={classes.media} image={viewOrderImage} title="View Orders" />
            <CardContent>
                <Typography variant="body2" color="textSecondary" component="p">
                    View your orders, check their status, access dentist links to review and approve cases as well as
                    patient links
                </Typography>
            </CardContent>
            <CardActions>
                <Button size="small" color="secondary" onClick={handleViewOrder}>
                    View
                </Button>
            </CardActions>
        </Card>
    );

    const CreateRefinementCard = () => (
        <Card className={classes.cardMedia}>
            <CardHeader title="Create a Refinement" />
            <CardMedia className={classes.media} image={newOrderImage} title="Create a Refinement" />
            <CardContent>
                <Typography variant="body2" color="textSecondary" component="p">
                    View a list of the complete orders and select the one one you want to refine
                </Typography>
            </CardContent>
            <CardActions>
                <Button
                    size="small"
                    color="secondary"
                    onClick={() => history.push('/app/order/list?orderStatus=complete')}
                >
                    Create
                </Button>
            </CardActions>
        </Card>
    );

    const OtherLabWorksCard = () => (
        <Card className={classes.cardMedia}>
            <CardHeader title="Order Other Lab Works" />
            <CardMedia className={classes.media} image={otherLabWorksImage} title="Order Other Lab Works" />
            <CardContent>
                <Typography variant="body2" color="textSecondary" component="p">
                    Click here to order fixed wires, splints, ortho appliances, sleep apnea appliances, crowns,
                    partial dentures and more…
                </Typography>
            </CardContent>
            <CardActions>
                <Button size="small" color="secondary" onClick={handleOtherLabWorks}>
                    Order
                </Button>
            </CardActions>
        </Card>
    );

    const SectionSeparator = ({ label }) => (
        <div className={classes.sectionSeparator}>
            <div className={classes.separatorLine} />
            <Typography className={classes.separatorLabel} component="h2">
                {label}
            </Typography>
            <div className={classes.separatorLine} />
        </div>
    );

    return (
        <>
            <Grid justifyContent="center" container>
                <CreateOrderCard />
                <ViewOrdersCard />
            </Grid>

            <Grid justifyContent="center" container>
                <CreateRefinementCard />
                <OtherLabWorksCard />
            </Grid>

            <Grid justifyContent="center" container>
                <SectionSeparator label="Latest News & Updates" />
            </Grid>

            <Grid justifyContent="center" container>
                {newsData.length > 0 && <NewsBanner newsItems={newsData} />}
            </Grid>
        </>
    );
};

export default Dashboard;
